import { NgModule } from "@angular/core";
import {
  MedBtnModule,
  MedCardModule,
  MedCheckboxModule,
  MedDirectiveSharedModule, MedInputModule, MedModalModule,
  MedPaginationModule, MedRadioGroupModule,
  MedSwitchModule,
  MedTabGroupModule, MedUnitInfoCardModule,
} from "@mk/med-ui";
import { DatePipe, NgClass, NgForOf, NgIf, NgStyle } from "@angular/common";
import { SharedModule } from "primeng/api";
import { TableModule } from "primeng/table";
import { AccordionModule } from "primeng/accordion";
import {
    MedIconAimbulanceModule,
    MedIconArrowRightModule,
    MedIconAvatarModule,
    MedIconCheckCircleFillModule,
    MedIconCloseModule,
    MedIconDeleteModule,
    MedIconHistoryModule,
    MedIconKeyLargeModule,
    MedIconNotificationModule,
    MedIconPlusModule, MedIconRefreshModule,
    MedIconSyncModule,
} from "@mk/med-icons";
import { BasketComponent } from "@app/components/basket/basket.component";
import { PageTitleModule } from "@app/components/page-title/page-title.module";
import { TooltipModule } from "primeng/tooltip";
import {FormsModule} from "@angular/forms";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {SidebarModule} from "primeng/sidebar";

@NgModule({
  declarations: [
    BasketComponent,
  ],
    imports: [
        PageTitleModule,
        MedDirectiveSharedModule,
        MedSwitchModule,
        MedTabGroupModule,
        DatePipe,
        MedCheckboxModule,
        MedPaginationModule,
        MedRadioGroupModule,
        NgForOf,
        NgIf,
        SharedModule,
        TableModule,
        AccordionModule,
        MedCardModule,
        NgStyle,
        MedBtnModule,
        MedIconNotificationModule,
        MedIconKeyLargeModule,
        MedIconAimbulanceModule,
        MedUnitInfoCardModule,
        MedIconArrowRightModule,
        MedIconDeleteModule,
        MedModalModule,
        NgClass,
        MedIconAvatarModule,
        MedIconCheckCircleFillModule,
        TooltipModule,
        MedIconSyncModule,
        FormsModule,
        OverlayPanelModule,
        MedIconPlusModule,
        MedIconCloseModule,
        MedIconHistoryModule,
        MedInputModule,
        SidebarModule,
        MedIconRefreshModule,
    ],
  exports: [],
})
export class BasketModule {}
